import { useContext } from 'react';
import { ToastContext } from 'utils/context/toastContext';

export function useToast() {
  return useContext(ToastContext);
}
